module.exports = __webpack_public_path__ + "static/media/service1.ea85ed63.png";